<template>
    <div v-if="show">
        <div id="flash-message" class="alert alert-info" role="alert" style="display: none"></div>
        <div v-if="!only_tutor" class="btn btn-primary positive text-center all-btn" :class="{ active: allFiles }" @click="showAll()">
            {{ trans("lms.AllFiles") }}
        </div>
        <button v-if="!only_tutor" id="create_folder_button" class="btn btn-primary positive text-center all-btn" style="width:auto !important;" onclick="createFolder()">
            {{ trans("lms.NewFolder") }}
        </button>
        <div class="tabs-container">
            <ul class="nav nav-tabs vue-tabs" id="model-names">
                <div class="form-group">
                    <label for="input-search" class="sr-only">Search Tree:</label>
                    <input type="input" class="form-control" id="input-search" :placeholder="trans('lms.TypeToSearch')" value="">
                </div>
                <div id="tree" style="max-block-size: fit-content;"></div>
            </ul>
        </div>
    </div>
</template>

<script>
import Bus from "../bus";
export default {

    props: ["only_tutor"],

    data() {
        return {
            models: [],
            tabname: "",
            content: [],
            model_id: "",
            isAdmin: false,
            only_tutor: false,
            show: true,
            allFiles: true,
        };
    },
    methods: {
        removeMarked() {
            $(".model-tabs").each(function () {
                $(this).removeClass("active-model");
            });
        },

        mark(e) {
            e.preventDefault();
            this.removeMarked();
            this.allFiles = false;
            $(e.target).addClass("active-model");
        },

        showAll() {
            this.removeMarked();
            this.allFiles = true;
            this.content = [];
            this.tabname = "";
            $("#model-names li").each(function () {
                $(this).removeClass("active");
            });
            localStorage.removeItem("media_id");
            localStorage.removeItem("media_type");
            let uri = "/media/allmedia";

            axios
                .post(uri, {
                    id: "all",
                    type: "all",
                })
                .then(function (response) {
                    Bus.$emit("all-files", response.data);
                    sessionStorage.setItem('selected_folder', 0);
                    window.unselectAllNodes();
                });
        },

        sendname(name) {
            this.removeMarked();
            this.allFiles = false;
            let uri = "/admin/media/models/content";

            localStorage.removeItem("media_id");
            localStorage.removeItem("media_type");

            localStorage.setItem("media_type", name);

            axios
                .post(uri, {
                    name: name,
                })
                .then((response) => {
                    this.content = response.data;
                    Bus.$emit("tab-change", name);
                });
            this.tabname = name;
        },

        getInfo(name, id) {
            if (localStorage.getItem("current_model_id")) {
                localStorage.removeItem("current_model_id");
            }
            localStorage.setItem("current_model_id", id);
            localStorage.setItem("media_type", name);

            let uri = "/admin/media/getfiles";

            axios
                .post(uri, {
                    type: name,
                    id: id,
                })
                .then((response) => {
                    Bus.$emit("files-data", response.data);
                });
        },

        drop(name, event) {
            event.preventDefault();
            if (localStorage.getItem("model_id_for_file")) {
                localStorage.removeItem("model_id_for_file");
            }
            localStorage.setItem("model_id_for_file", name["id"]);
            this.move();
        },
        move() {
            axios
                .post("/admin/media/movefileto", {
                    model_type: this.tabname,
                    model_id: localStorage.getItem("model_id_for_file"),
                    media_id: localStorage.getItem("media_id"),
                })
                .then((response) => {
                    if (typeof response.data["messageSuccess"] !== "undefined") {
                        window.notification("success", response.data["messageSuccess"]);
                        Bus.$emit("file-moved", response.data["id"]);
                    } else {
                        window.notification("danger", response.data["messageError"]);
                    }
                });
        },
    },
    mounted() {
        let currentUrl, getModelsUri, getClientUri;
        currentUrl = window.location.href;
        if (currentUrl.indexOf("/files") > -1) {
            getModelsUri = "/files/models";
            getClientUri = "/files/getclientid";
        }
        if (currentUrl.indexOf("inline_newsletter") > -1) {
            this.show = false;
        } else {
            getModelsUri = "/media/models";
            getClientUri = "/media/getclientid";
        }

        // axios.get(getModelsUri).then((response) => {
        //     this.models = response.data;
        // });
        axios.get(getClientUri).then((response) => {
            this.isAdmin = response.data["admin"];
        });
        window.vue = this;
    },
};
</script>

<style scoped lang="scss">
#model-names {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;

    li {
        width: 100%;

        a {
            border-radius: 4px;
            margin-bottom: 2px;
        }
    }
}

.model-content {
    margin-top: 60px;
    list-style: none;
    padding: 3px;
}

.model-content li {
    display: block;
    padding: 5px;
    border-radius: 5px;
    margin-bottom: 5px;
}

.model-tabs {
    overflow: hidden;
}

.model-tabs:hover {
    background: #f4f4f4;
    cursor: pointer;
}

.active-model {
    background-color: #55b7e9 !important;
}

.all-btn {
    width: 100%;
    margin-bottom: 15px;
}

.model-overlay {
    height: 0%;
    position: fixed;
    z-index: 1;
    top: 129px;
    background-color: rgb(0, 0, 0);
    background-color: rgba(255, 255, 255, 0.9);
    overflow-y: hidden;
    transition: 0.5s;
    margin-left: -15px;
}

.model-overlay-content {
    position: relative;
    top: 5%;
    width: 100%;
    text-align: center;
    margin-top: 30px;
}

.model-overlay a {
    padding: 8px;
    text-decoration: none;
    font-size: 25px;
    color: #818181;
    display: inline-block;
    transition: 0.3s;
}

.model-overlay #q {
    padding: 8px;
    text-decoration: none;
    font-size: 20px;
    color: #818181;
    display: inline-block;
    transition: 0.3s;
}

.model-overlay a:hover,
.model-overlay a:focus {
    color: #5bc0de;
    border-bottom: 1px solid #000;
}

.closebtn:hover,
.closebtn:focus {
    border-bottom: none !important;
}

.model-overlay .closebtn {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 60px;
}

.hiddenp {
    display: none;
    margin-top: 50px;
    color: #5bc0de;
    border: 1px solid #5bc0de;
    border-radius: 5px;
    font-size: 12px;
    padding: 5px;
}

.statusp {
    margin-top: 50px;
    border-radius: 5px;
    font-size: 12px;
    padding: 5px;
}

.greenp {
    color: green;
    border: 1px solid green;
}

.redp {
    color: red;
    border: 1px solid red;
}

.transparent {
    background-color: transparent !important;
}

.tabs-container {
    height: 607px;
    margin-top: -5px;
    overflow: hidden;
    overflow-y: auto;
}

@media screen and (max-width: 991px) {
    .tabs-container {
        height: auto;
    }

    .model-content {
        display: flex;
        flex-direction: column;
        justify-content: start;
        overflow-x: auto;
    }

    .model-content li {
        margin-right: 5px;
        padding-left: 10px;
        padding-right: 10px;
    }
}

@media screen and (max-height: 450px) {
    .model-overlay {
        overflow-y: auto;
    }

    .model-overlay a {
        font-size: 20px;
    }

    .model-overlay .closebtn {
        font-size: 40px;
        top: 0;
        right: 0;
    }
}
</style>
